export enum EnumTipoPropagandaPessoa {
    NaoExibir = 0,
    Saurus = 1,
    Whitelabel = 2,
}